module.exports = __webpack_public_path__ + "static/media/tenThousuand.dec6bd0f.ogg";